<template>
  <div>
    <el-row class="margin-top-lg">
      <el-col :span="24" class="text-right" v-if="simplifyEvBikeInfo.roomId">
        <el-button type="primary" size="small" @click="_addEvBike">
          <i class="el-icon-plus"></i> {{ $t('simplifyEvBike.addBike') }}
        </el-button>
      </el-col>
    </el-row>

    <div class="margin-top">
      <el-table :data="simplifyEvBikeInfo.evBikes" style="width: 100%; margin-top:10px" border>
        <el-table-column prop="plateNumber" :label="$t('simplifyEvBike.plateNumber')" align="center"></el-table-column>
        <el-table-column prop="brandModel" :label="$t('simplifyEvBike.brandModel')" align="center"></el-table-column>
        <el-table-column prop="ownerName" :label="$t('simplifyEvBike.owner')" align="center"></el-table-column>
        <el-table-column prop="ownerPhone" :label="$t('simplifyEvBike.phone')" align="center"></el-table-column>
        <el-table-column :label="$t('simplifyEvBike.room')" align="center">
          <template #default="{row}">
            {{row.building}}-{{row.unit}}-{{row.room}}
          </template>
        </el-table-column>
        <el-table-column :label="$t('simplifyEvBike.status')" align="center">
          <template #default="{row}">
            <span v-if="row.state === '1001'">{{ $t('simplifyEvBike.stateNormal') }}</span>
            <span v-else-if="row.state === '2002'">{{ $t('simplifyEvBike.stateDisable') }}</span>
            <span v-else-if="row.state === '3003'">{{ $t('simplifyEvBike.stateLost') }}</span>
            <span v-else>{{ row.state }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('simplifyEvBike.issueStatus')" align="center">
          <template #default="{row}">
            <span v-if="(row.issueStatus || 'W') === 'W'">{{ $t('simplifyEvBike.issuePending') }}</span>
            <span v-else-if="row.issueStatus === 'S'">{{ $t('simplifyEvBike.issueDone') }}</span>
            <span v-else-if="row.issueStatus === 'F'">{{ $t('simplifyEvBike.issueFailed') }}</span>
            <span v-else>{{ row.issueStatus }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('simplifyEvBike.auditStatus')" align="center">
          <template #default="{row}">
            <el-tag v-if="row.auditStatus === 'W'" type="warning">{{ $t('simplifyEvBike.auditPending') }}</el-tag>
            <el-tag v-else-if="row.auditStatus === 'P'" type="success">{{ $t('simplifyEvBike.auditPassed') }}</el-tag>
            <el-tag v-else-if="row.auditStatus === 'R'" type="danger">{{ $t('simplifyEvBike.auditRejected') }}</el-tag>
            <span v-else>{{ row.auditStatus }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('simplifyEvBike.auditInfo')" align="center" width="200">
          <template #default="{row}">
            <div v-if="row.auditUserName">
              <div>{{ row.auditUserName }}</div>
              <div style="font-size: 12px; color: #999;">{{ row.auditTime ? row.auditTime.substring(0, 16) : '' }}</div>
            </div>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('simplifyEvBike.createTime')" align="center">
          <template #default="{row}">
            {{ row.createTime ? row.createTime.substring(0, 16) : '' }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('simplifyEvBike.operation')" align="center" width="260">
          <template #default="{row}">
            <el-button
              v-if="row.auditStatus && row.auditStatus !== 'W'"
              type="text"
              @click="_openIssueEvBike(row)">
              <span v-if="(row.issueStatus || 'W') === 'W'">{{ $t('simplifyEvBike.issue') }}</span>
              <span v-else>{{ $t('simplifyEvBike.reissue') }}</span>
            </el-button>
            <el-button v-if="row.auditStatus === 'W'" type="text" @click="_openAuditEvBike(row)">
              {{ $t('simplifyEvBike.audit') }}
            </el-button>
            <el-button type="text" @click="_openEditEvBike(row)">
              {{ $t('simplifyEvBike.edit') }}
            </el-button>
            <el-button type="text" @click="_openDelEvBikeModel(row)">
              {{ $t('simplifyEvBike.delete') }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-row>
        <el-col :span="12"></el-col>
        <el-col :span="12" class="text-right">
          <el-pagination @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize"
            layout="total, prev, pager, next" :total="simplifyEvBikeInfo.total"></el-pagination>
        </el-col>
      </el-row>
    </div>

    <edit-ev-bike ref="editEvBike" @listEvBikeData="_refreshList"></edit-ev-bike>
    <delete-ev-bike ref="deleteEvBike" @listEvBikeData="_refreshList"></delete-ev-bike>
    <audit-ev-bike ref="auditEvBike" @listEvBikeData="_refreshList"></audit-ev-bike>
    <issue-ev-bike ref="issueEvBike" @listEvBikeData="_refreshList"></issue-ev-bike>
  </div>
</template>

<script>
import { getCommunityId } from '@/api/community/communityApi'
import { queryEvBikes } from '@/api/evbike/evBikeApi'
import EditEvBike from '@/components/evbike/editEvBike'
import DeleteEvBike from '@/components/evbike/deleteEvBike'
import AuditEvBike from '@/components/evbike/auditEvBike'
import IssueEvBike from '@/components/evbike/issueEvBike'

export default {
  name: 'SimplifyEvBike',
  components: {
    EditEvBike,
    DeleteEvBike,
    AuditEvBike,
    IssueEvBike
  },
  data() {
    return {
      simplifyEvBikeInfo: {
        evBikes: [],
        ownerId: '',
        ownerName: '',
        ownerPhone: '',
        roomId: '',
        total: 0,
        records: 1
      },
      currentPage: 1,
      pageSize: 10,
      total: 0,
      communityId: ''
    }
  },
  created() {
    this.communityId = getCommunityId()
  },
  methods: {
    open(params) {
      this.switchData(params)
    },

    switchData(param) {
      if (!param.roomId || param.roomId === '') return
      this.clearSimplifyEvBikeInfo()
      Object.assign(this.simplifyEvBikeInfo, param)
      this.currentPage = 1
      this._listSimplifyEvBike(1, 10)
    },

    clearSimplifyEvBikeInfo() {
      this.simplifyEvBikeInfo = {
        evBikes: [],
        ownerId: '',
        ownerName: '',
        ownerPhone: '',
        roomId: '',
        total: 0,
        records: 1
      }
      this.currentPage = 1
      this.total = 0
    },

    async _listSimplifyEvBike(page, row) {
      if (!this.simplifyEvBikeInfo.ownerId) {
        return
      }

      try {
        const res = await queryEvBikes({
          page,
          row,
          ownerId: this.simplifyEvBikeInfo.ownerId,
          communityId: this.communityId
        })

        if (res.code != 0) {
          this.$message.error(res.msg)
          return
        }

        this.simplifyEvBikeInfo.evBikes = res.data || []
        this.total = res.total || 0
        this.simplifyEvBikeInfo.total = res.total || 0
        this.simplifyEvBikeInfo.records = res.records || 1
      } catch (error) {
        this.$message.error(error.message || '查询电动车失败')
      }
    },

    handleCurrentChange(val) {
      this.currentPage = val
      this._listSimplifyEvBike(val, this.pageSize)
    },

    _addEvBike() {
      this.$refs.editEvBike.open({
        ownerId: this.simplifyEvBikeInfo.ownerId,
        ownerName: this.simplifyEvBikeInfo.ownerName,
        ownerPhone: this.simplifyEvBikeInfo.ownerPhone,
        roomOwnerName: this.simplifyEvBikeInfo.ownerName,
        roomOwnerPhone: this.simplifyEvBikeInfo.ownerPhone,
        isAdd: true
      })
    },

    _openEditEvBike(row) {
      this.$refs.editEvBike.open({
        ...row,
        roomOwnerName: this.simplifyEvBikeInfo.ownerName,
        roomOwnerPhone: this.simplifyEvBikeInfo.ownerPhone,
        isAdd: false
      })
    },

    _openDelEvBikeModel(row) {
      this.$refs.deleteEvBike.open(row)
    },

    _openAuditEvBike(row) {
      this.$refs.auditEvBike.open(row)
    },

    _openIssueEvBike(row) {
      this.$refs.issueEvBike.open(row)
    },

    _refreshList() {
      this._listSimplifyEvBike(this.currentPage, this.pageSize)
    }
  }
}
</script>

<style scoped>
.margin-top-lg {
  margin-top: 20px;
}

.margin-top {
  margin-top: 15px;
}

.padding-right-xs {
  padding-right: 5px;
}

.padding-left-xl {
  padding-left: 20px;
}

.text-right {
  text-align: right;
}
</style>
